export const fileTypesUnsafeBehavior = ['.jpg', '.jpeg', '.png'];
